export const CUSTOM_PAGE_SIZE = 5;
export const STATE_PROP_NOTIFICATION = 'notificationOverview';
export const SEVERITIES = ['ALERT', 'NEED_FOR_ACTION'];
